const fetchData = () => {
    return fetch('/api/parameters')
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .catch((error) => {
            console.error('There was a problem with the fetch operation:', error);
            throw error;
        });
};

export default fetchData;